import { render } from "./DateMarker.vue?vue&type=template&id=97dda32c&ts=true"
import script from "./DateMarker.vue?vue&type=script&lang=ts"
export * from "./DateMarker.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__